import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../redux/authSlice";
import { handleAPIRequest } from "../../api/api";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../homepage/navbar/Navbar"; // Import Navbar component

const Login2 = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const handleSignUp = () => navigate("/signup");

  const handleLogin = async () => {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    try {
      const response = await handleAPIRequest("post", "login", formData);

      const { Role, token, User, affiliatedDetails, membershipStatus } = response;

      dispatch(
        loginSuccess({
          token,
          role: Role,
          user: User,
          affiliatedDetails,
          membershipStatus,
        })
      );

      if (Role === "super_admin" || Role === "admin") {
        navigate("/dashboard/admin");
      } else if (Role === "editor") {
        navigate("/dashboard/admin/blog-details");
      } else if (Role === "company_owner" || Role === "company_user") {
        navigate(`/dashboard/company`);
      } else if (Role === "supplier_owner") {
        navigate(`/dashboard/supplier`);
      } else if (Role === "donor_owner") {
        navigate(`/dashboard/donor`);
      } else {
        toast.error("Unauthorized role");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Login failed. Please check your credentials.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-cover bg-center bg-gray-300">
      <Navbar /> {/* Add Navbar here */}
      <div className="flex justify-center items-center mt-10 p-6 w-full h-full">
        {/* Login Form Section */}
        <div className="w-full max-w-lg p-10 ">
          <h1 className="text-4xl font-bold text-center mb-8">Login to NGOs Tenders Portal</h1>

          <div className="mb-6">
            <input
              type="email"
              className="w-full py-5 px-6 text-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              style={{ borderRadius: "30px" }}
              placeholder="Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-6">
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full py-5 px-6 text-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
                style={{ borderRadius: "30px" }}
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-600"
                onClick={handleClickShowPassword}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="flex items-center justify-between mb-6">
            <label className="flex items-center text-md text-gray-600">
              <input type="checkbox" className="mr-2" />
              Remember Me
            </label>
            <Link to="/forget-password" className="text-md text-gray-600 hover:underline">
              Forgot Password?
            </Link>
          </div>

          <button
            onClick={handleLogin}
            className="w-full py-5 px-6 bg-black text-white text-lg font-semibold hover:bg-gray-800 transition-all"
            style={{ borderRadius: "30px" }}
          >
            Login
          </button>

          <p className="mt-6 text-center text-lg">
            <Link to="/signup" className="text-gray-600 hover:underline">
              Don't have an Account? <b>Sign Up</b>
            </Link>
          </p>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login2;
